export function PageLoading({ label }: { label: string }) {
  return (
    <div className="page-loading shell" role="status" aria-live="polite">
      <span className="spinner" aria-hidden="true" />
      <span>{label}…</span>
    </div>
  )
}
